export const messageOwnerType = {
    teacher: 0,
    admin: 1,
}
